import { MapPin } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { Eyebrow, GradientText } from "@/components/Brand";

const AREAS = [
  "Narre Warren", "Narre Warren South", "Berwick", "Beaconsfield", "Officer",
  "Pakenham", "Clyde", "Cranbourne", "Hampton Park", "Hallam", "Dandenong",
  "Endeavour Hills", "Fountain Gate", "Mulgrave", "Glen Waverley", "Springvale",
  "Frankston", "Carrum Downs",
];

export default function ServiceAreas() {
  return (
    <section className="bg-white py-24 md:py-28" data-testid="service-areas-section">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl">
          <Eyebrow>Service Areas</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Air Conditioning Across <GradientText>Melbourne &amp; Victoria</GradientText>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-mutedblue">
            Based in Narre Warren, our team services Melbourne's south east and surrounding
            Victorian areas, including:
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-10 flex flex-wrap gap-3" data-testid="service-areas-list">
            {AREAS.map((a) => (
              <li
                key={a}
                className="inline-flex items-center gap-2 rounded-full border border-cardline bg-offwhite px-4 py-2 text-sm font-medium text-ink transition-[border-color,color] duration-200 hover:border-brand-cyan hover:text-navy"
              >
                <MapPin className="h-3.5 w-3.5 text-brand-blue" aria-hidden="true" />
                {a}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-sm leading-relaxed text-mutedblue">
            Outside these areas? We service right across greater Melbourne and regional Victoria —
            call <a href="tel:+61423250130" className="font-semibold text-brand-blue hover:underline">+61 423 250 130</a> to
            confirm availability for your property.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
